import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import SimpleBar from "simplebar-react";
//import logo
import logoSm from "../assets/images/logoSm.svg";
import logoSmDark from "../assets/images/logoSmDark.svg";
// import logoDark from "../assets/images/logo-dark.png";
import logoLight from "../assets/images/logo-light.svg";
import logoDark from "../assets/images/logo-dark.svg";

//Import Components
import VerticalLayout from "./VerticalLayouts";
import { Container } from "reactstrap";
import { useMatchedParams } from "../slices/auth/settings/helper";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import { setBreadcrumb } from "../slices/auth/menu/reducer";
import TopMenuDropdown from './Header/TopMenuDropdown';
import { setBrandPath, setClientPath, setMarketPath } from "../slices/auth/menu/thunk";
import { getFeedSuccess, setFeedsFirstLoad, setFeedsHasMore, setFeedsLoading, setFeedsPage } from "../slices/feeds/reducer";
import { getAllLibrariesSuccess, setAllLibrariesFirstLoad, setAllLibrariesHasMore, setAllLibrariesLoading, setAllLibrariesPage } from "../slices/campaigns/reducer";
import { resetTableFilter } from "../slices/folder/thunk";

const Sidebar = ({ layoutType }) => {
	const dispatch = useDispatch();
	const params = useParams();
	const location = useLocation();
	const path = location.pathname;
	const appMenuRef = useRef(null);
	const [simplebarMaxHeight, setSimplebarMaxHeight] = useState(0);
	useEffect(() => {
		var verticalOverlay = document.getElementsByClassName("vertical-overlay");
		if (verticalOverlay) {
			verticalOverlay[0].addEventListener("click", function () {
				document.body.classList.remove("vertical-sidebar-enable");
			});
		}
	});

	const addEventListenerOnSmHoverMenu = () => {
		// add listener Sidebar Hover icon on change layout from setting
		if (document.documentElement.getAttribute("data-sidebar-size") === "sm-hover") {
			document.documentElement.setAttribute("data-sidebar-size", "sm-hover-active");
		} else if (document.documentElement.getAttribute("data-sidebar-size") === "sm-hover-active") {
			document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
		} else {
			document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
		}
	};

	const selectMenuState = createSelector(state => state, state => ({
		menuData: state.MenuData.client
	}))
	const { menuData } = useSelector(selectMenuState);

	function setLogoHref() {
		const paramNames = Object.keys(params);
		let remainingPath = path;
		paramNames.forEach(paramName => {
			remainingPath = remainingPath.replace(`/${params[paramName]}`, '');
		});
		remainingPath = remainingPath.replace(/^\/|\/$/g, '')
		if (remainingPath.includes('/')) {
			remainingPath = remainingPath.split('/')[0]
		}
		if (remainingPath.includes('publish')) {
			remainingPath = remainingPath.replace('publish', 'campaigns');
		}
		if (remainingPath.includes('settings')) {
			return '/settings'
		} else {
			return remainingPath;
		}
	}

	function resetBreadcrumb() {
		dispatch(setClientPath(null));
		dispatch(setBrandPath(null));
		dispatch(setMarketPath(null));
		dispatch(resetTableFilter());
		dispatch(setBreadcrumb({ pageTitle: '', title: [] }));
	}

	useEffect(() => {
		if (appMenuRef) {
			window.addEventListener('resize', calculateSimplebarMaxHeight)
		}

		return () => {
			window.removeEventListener('resize', calculateSimplebarMaxHeight)
		}
	}, [appMenuRef]);

	function calculateSimplebarMaxHeight() {
		if (appMenuRef.current) {
			if (window.location.href.includes('settings')) {
				setSimplebarMaxHeight(appMenuRef.current.offsetHeight - 100);				
			} else {
				setSimplebarMaxHeight(appMenuRef.current.offsetHeight - 200);
			}
		}
	}

	return (
		<React.Fragment>
			<div className="app-menu navbar-menu" ref={appMenuRef}>
				<div className="navbar-brand-box">
					<Link to={setLogoHref()} onClick={resetBreadcrumb} className="logo logo-dark">
						<span className="logo-sm">
							<img src={logoSm} alt="" height="22" draggable="false" />
						</span>
						<span className="logo-lg">
							<img src={logoLight} alt="" height="34" draggable="false" />
						</span>
					</Link>

					<Link to={setLogoHref()} onClick={resetBreadcrumb} className="logo logo-light">
						<span className="logo-sm">
							<img src={logoSmDark} alt="" height="22" draggable="false" />
						</span>
						<span className="logo-lg">
							<img src={logoDark} alt="" height="34" draggable="false" />
						</span>
					</Link>
					<button
						onClick={addEventListenerOnSmHoverMenu}
						type="button"
						className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
						id="vertical-hover"
					>
						<i className="ri-record-circle-line"></i>
					</button>
				</div>
				<React.Fragment>
					<TopMenuDropdown />
					<SimpleBar id="scrollbar" style={{ maxHeight: `${simplebarMaxHeight}px`}}>
						<Container fluid>
							<div id="two-column-menu"></div>
							<ul className="navbar-nav" id="navbar-nav">
								<VerticalLayout layoutType={layoutType} />
							</ul>
						</Container>
					</SimpleBar>
					<div className="sidebar-background"></div>
				</React.Fragment>
			</div>
			<div className="vertical-overlay"></div>
		</React.Fragment>
	);
};

export default Sidebar;